// The waste container picker of a depollution result (Stage 6 slice 2, D4): the pick list rows as
// select items, suggested first (the API orders them), in the result's unit, and a scanned label
// matched against them. Pure: no Vue, no API calls.
import { isContainerId } from "./wasteList.mjs";

// GET /waste/containers/pick rows -> [{ value, name, unit, unitKey, code, suggested }]. With a
// unit only the containers in that unit are offered; the selected one always stays listed.
export function pickItems(containers, { unit = null, selectedId = null } = {}) {
  return (containers || [])
    .filter((c) => !unit || c.unit === unit || c.id === selectedId)
    .map((c) => ({
      value: c.id,
      name: c.name,
      unit: c.unit,
      unitKey: `waste.unit.${c.unit}`,
      code: c.code || "",
      suggested: c.suggested === true,
    }));
}

// The pick list row of an id, or null.
export function pickedRow(containers, id) {
  return (containers || []).find((c) => c.id === id) || null;
}

// A scanned label (the plain container id, D3) -> { id } of a listed container, or { error }:
// "invalid_code" (not a container QR, e.g. a car's: both are ids, so a car id ends as
// "not_found") or "not_found" (not offered here: another institution's, inactive or an area).
export function scanMatch(text, containers) {
  const value = String(text == null ? "" : text)
    .trim()
    .toLowerCase();
  if (!isContainerId(value)) return { error: "invalid_code" };
  const row = pickedRow(containers, value);
  return row ? { id: row.id } : { error: "not_found" };
}
